import React, { useEffect, useRef } from 'react';
import { service, factories, models } from 'powerbi-client';

/**
 * @typedef {Object} PowerBIReportProps
 * @property {string} REPORT_ID
 * @property {string} GROUP_ID
 * @property {string} ACCESS_TOKEN
 */

const powerbi = new service.Service(
  factories.hpmFactory,
  factories.wpmpFactory,
  factories.routerFactory
);

/**
 * @param {PowerBIReportProps} props
 */
const PowerBIReport = ({ REPORT_ID, GROUP_ID, ACCESS_TOKEN }) => {
  const reportContainerRef = useRef(null);

  useEffect(() => {
    const embedReport = async () => {
      try {
        const embedConfiguration = {
          type: 'report',
          id: REPORT_ID,
          embedUrl: `https://app.powerbi.com/reportEmbed?reportId=${REPORT_ID}&groupId=${GROUP_ID}`,
          accessToken: ACCESS_TOKEN,
          tokenType: models.TokenType.Embed,
          settings: {
            panes: {
              filters: { visible: false },
              pageNavigation: { visible: true },
            },
            background: models.BackgroundType.Transparent,
          },
        };

        const report = powerbi.embed(reportContainerRef.current, embedConfiguration);

        return () => {
          report.destroy();
        };
      } catch (error) {
        console.error('Erro inesperado:', error);
      }
    };

    embedReport();
  }, [REPORT_ID, GROUP_ID, ACCESS_TOKEN]);

  return (
    <div
      ref={reportContainerRef}
      style={{ height: '800px', width: '100%' }}
    />
  );
};

export default PowerBIReport;
